<template>
    <header class="navbar fixed-top" id="header">
      <!-- wrap-->
      <div class="container-fluid px-6">
      <b-navbar toggleable="lg" class="w-100 bg-white fixed-top">
      <b-navbar-brand href="/">
        <router-link :to="{ name: 'home' }">
          <img
            class="logo"
            src="/static/img/logo.jpg"
            v-bind:alt="project.brandName"
          />
        </router-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <!--      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>-->
      <b-collapse id="nav-collapse" class="justify-content-end" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="menu bg-white p-2">
          <div>
            <b-nav-item>
              <router-link
                active-class="menu-item-active"
                :to="{ name: 'aboutUs' }"
                v-b-tooltip.hover.bottom
                class="menu-item"
              >
                About
              </router-link>
            </b-nav-item>
          </div>
          <div>
            <b-nav-item>
              <router-link
                active-class="menu-item-active"
                :to="{ name: 'whatWeOffer' }"
                class="menu-item"
              >
                Services
              </router-link>
            </b-nav-item>
          </div>
          <div>
            <b-nav-item>
              <router-link
                active-class="menu-item-active"
                :to="{ name: 'OurUsers' }"
                class="menu-item"
              >
                Target groups
              </router-link>
            </b-nav-item>
          </div>
          <div>
            <b-nav-item>
              <router-link
                active-class="menu-item-active"
                :to="{ name: 'PublicAssets' }"
                class="menu-item"
              >
                Public assets
              </router-link>
            </b-nav-item>
          </div>

          <div>
            <b-nav-item ref="global-search" link-classes="search-button">
              <b-button
                class="clbutton"
                @click="globalSearch"
                size="sm"
                target="_blank"
              >
                <font-awesome-icon icon="search" />
                Search
              </b-button>
            </b-nav-item>
          </div>

          <div v-if="!authenticatedUser">
            <b-nav-item>
              <router-link
                :to="{ name: 'login' }"
                class="menu-item font-weight-bold"
              >
                <i class="fas fa-sign-in-alt mr-2"></i>Join
              </router-link>
            </b-nav-item>
          </div>
          <div v-else>
            <b-nav-item-dropdown menu-class="mx-2 mt-n1">
              <template v-slot:button-content>
                <span class="text-dark p-1" id="user-container">
                  <span>{{ user }}</span>
                </span>
              </template>
              <!--              <b-dropdown-item @click="routeToRecipes">-->
              <!--                  <router-link :to="{name: 'recipes'}" class="action-btns">Recipes</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-item @click="routeToResources">-->
              <!--                <router-link :to="{name: 'resources'}" class="action-btns">Resources</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-item @click="routeToOrganizations">-->
              <!--                <router-link :to="{name: 'organizations'}" class="action-btns">Organizations</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-item @click="routeToGroups">-->
              <!--                <router-link :to="{name: 'groups'}" class="action-btns">Groups</router-link>-->
              <!--              </b-dropdown-item>-->
              <!--              <b-dropdown-divider></b-dropdown-divider>-->
              <b-dropdown-item :to="{ name: 'account' }"
                >My profile</b-dropdown-item
              >
              <!-- <b-dropdown-item :to="{ name: 'accountEdit' }"
                >Edit profile</b-dropdown-item
              > -->
              <b-dropdown-item @click.prevent="userLogout"
                >Logout</b-dropdown-item
              >
            </b-nav-item-dropdown>
          </div>
          <!-- <div v-if="!authenticatedUser">
            <b-nav-item><font class="pr-3"><i>or</i></font>
              <router-link :to="{ name: 'signup' }" class="text-dark">
               Sign up
              </router-link>
            </b-nav-item>
          </div> -->
          <b-nav-item v-if="authenticatedUser">
            <NotificationBell/>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
      </div>
    </header>

</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import SearchPlugin from "../plugins/SearchPlugin";
// import NotificationFeed from "./notifications/NotificationFeed";
// import NotificationFeedUnhandled from "./notifications/NotificationFeedUnhandled";
import NotificationBell from "./notifications/NotificationBell";
import config from "../../config";

export default {
  components: {  NotificationBell  },
  data() {
    return {
      search: "",
      searchResult: "",
      organisationName: "",
      recipeName: "",
      resourceName: "",
      notificationCount: null,
      allnotificationsAmount: null
    };
  },
  props: {
    project: Object,
  },
  created() {
    eventBus.$on("organisationSearchedName", (data) => {
      this.searchResult = data;
    });
    eventBus.$on("organisationSearchNull", (data) => {
      this.searchResult = data;
    });
    eventBus.$on("forgetGlobalSearch", (data) => {
      this.search = data;
    });
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    user() {
      // get the fullname of the logged in user
      if (Object.keys(this.$store.state.user).length > 0) {
        return this.$store.state.user.name;
      }
      return "";
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  methods: {
    globalSearch() {
      this.search = "global";
      this.showAll();
    },
    userLogout(event) {
      // logout user
      this.$store.dispatch("logout");
      this.$router.push({ name: "home" });
    },
    // Search integration addition
    changeTerm(val) {
      this.sTerm = val;
    },
    showAll: function (token) {
      this.$search.toggleSearch();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    showView: function (event) {
      // // alert('View with type: ' + event.detail.type + ' and id: ' + event.detail.id)
      if (this.search === "global") {
        if (event.detail.type === "Organisation") {
          this.$router.push({
            name: "organizationView",
            params: { id: event.detail.id },
          });
          this.search = "";
        } else if (event.detail.type === "Recipe") {
          this.$router.push({
            name: "recipeView",
            params: { id: event.detail.id },
          });
          this.search = "";
        } else if (event.detail.type === "Resource") {
          this.$router.push({
            name: "resourceView",
            params: { id: event.detail.id },
          });
          this.search = "";
        }
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
    // Search integration addition
  },
};
</script>

<style lang="scss" scoped>
  .nav-item {
    margin-right: 10px;
  }

  .menu {
    display: flex;
    align-items: center;
    margin-right: 4rem;
  }
  .menu-item {
    font-size: 1rem;
    text-decoration: none;
    color: #343a40;
 
    &:hover {
      color: #EE861D;
      text-decoration: none;
    }
    &:active {
      text-decoration: none;
    }
  }
  .menu-item-active {
    color: #EE861D;
  }

  .search-button {
    padding-top: 12px;
  }

  #notifMenu {
    left: -200px;
  }


  #user-container {
    border: 2px solid #ee861e !important;
    border-radius: 5px;
  }

  .text-underline {
    text-decoration: underline !important;
  }

  #notifications .p1[data-count]:after {
    position: absolute;
    right: 2%;
    top: -10px;
    content: attr(data-count);
    font-size: 80%;
    padding: 0.4em;
    border-radius: 50%;
    line-height: 1em;
    color: white;
    background: rgba(255, 0, 0, 0.85);
    text-align: center;
    min-width: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue